import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Stránka nenalezena – Horsebeat.cz</title>
        <meta name="robots" content="noindex, follow" />
        <meta
          name="description"
          content="Tato stránka na Horsebeat.cz neexistuje nebo byla přesunuta. Vraťte se na úvodní stranu nebo pokračujte do dalších sekcí."
        />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <p className="text-sm font-semibold text-muted-foreground mb-2">
            Chyba 404
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-primary">
            Stránku jsme nenašli
          </h1>
          <p className="text-lg text-muted-foreground mb-6">
            Odkaz je zřejmě neplatný nebo byl obsah přesunut. Zkuste pokračovat
            do některé z hlavních sekcí:
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link
              to="/"
              className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90 transition"
            >
              Úvodní strana
            </Link>
            <Link
              to="/syndikaty"
              className="px-4 py-2 rounded-md border border-border hover:bg-secondary transition"
            >
              Spolumajitelství
            </Link>
            <Link
              to="/horses"
              className="px-4 py-2 rounded-md border border-border hover:bg-secondary transition"
            >
              Databáze koní
            </Link>
            <Link
              to="/race-results"
              className="px-4 py-2 rounded-md border border-border hover:bg-secondary transition"
            >
              Výsledky dostihů
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
